/**
 * @format
 * @Description: job实例状态机
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import { action, observable, useStrict } from 'mobx';
import Utils from 'utils';
import { message } from 'antd';
import { get, map } from 'lodash';

const CDN_BASE = 'assets';
useStrict(true);
class ReportMod {
  @observable
  dateString = null;

  @observable
  sourceData = [];

  @observable
  schedulerCount = 0;

  @observable
  taskCount = 0;

  @observable
  taskInstCount = 0;

  @observable
  myChart = null;

  @observable
  unit = '天';

  @action
  updateStore(payload) {
    for (let i in payload) {
      this[i] = payload[i];
    }
  }

  defaultDate() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
    end.setTime(end.getTime() + 60 * 1000);
    let date = [start, end];
    date = map(date, item => {
      return Utils.timeFormat(item);
    });
    return date;
  }
  getStatBeforeRequest = data => {
    let beginTime = get(data, ['time', '0', '_d']) ? data.time[0].format('YYYY-MM-DD HH:mm:ss') : get(data, ['time', '0'], '');
    let endTime = get(data, ['time', '1', '_d']) ? data.time[1].format('YYYY-MM-DD HH:mm:ss') : get(data, ['time', '1'], '');
    let obj = {
      beginTime: beginTime,
      endTime: endTime,
      appCode: data.appCode
    };
    if (beginTime == endTime) {
      this.updateStore({ unit: '时' });
    } else {
      this.updateStore({ unit: '天' });
    }
    return obj;
  };
  getStatAfterRequest = data => {
    const { schedulerCount, taskCount, taskInstCount, taskInstStatList, xList } = data;
    if (data.xList) {
      const x = xList.map(item => String(item));
      let sourceData = [['product', ...x]];
      taskInstStatList.forEach(ele => {
        sourceData.push([ele.status, ...ele.countDetail]);
      });
      if (this.myChart) {
        this.chartInit(this.myChart, sourceData);
      }
      this.updateStore({
        schedulerCount,
        taskCount,
        taskInstCount,
        sourceData
      });
    } else {
      message.warn('未查询到数据');
    }
  };

  chartInit(myChart, sourceData) {
    const option = {
      title: { text: '日期分布图' },
      legend: {},
      tooltip: {
        trigger: 'axis',
        showContent: false
      },
      dataset: {
        source: sourceData
      },
      xAxis: { type: 'category', name: this.unit },
      yAxis: { gridIndex: 0, name: '次数' },
      grid: { top: '55%' },
      series: [
        { type: 'line', smooth: true, seriesLayoutBy: 'row', color: '#9EC41F' },
        { type: 'line', smooth: true, seriesLayoutBy: 'row', color: '#D12938' },
        { type: 'line', smooth: true, seriesLayoutBy: 'row', color: '#66C4CC' },
        {
          type: 'pie',
          id: 'pie',
          radius: '30%',
          center: ['50%', '28%'],
          label: {
            formatter: '{b}: {@1} ({d}%)'
          },
          color: ['#9EC41F', '#D12938', '#66C4CC', '#318FA9'],
          encode: {
            itemName: 'product',
            value: '1',
            tooltip: '1'
          }
        }
      ]
    };
    myChart.on('updateAxisPointer', function(event) {
      var xAxisInfo = event.axesInfo[0];
      if (xAxisInfo) {
        var dimension = xAxisInfo.value + 1;
        myChart.setOption({
          series: {
            id: 'pie',
            label: {
              formatter: '{b}: {@[' + dimension + ']} ({d}%)'
            },
            encode: {
              value: dimension,
              tooltip: dimension
            }
          }
        });
      }
    });

    if (option && typeof option === 'object') {
      myChart.setOption(option, true);
    }
  }
}

// ES6单例写法
export default new ReportMod();



// WEBPACK FOOTER //
// ./src/pages/DispatchCenter/Report/ReportMod.js